import { useNewHeader } from '@/featureFlags/newHeader';

export default function useGTMEvents() {
  const newHeader = useNewHeader();

  function sendMenuClickEvent({
    section,
    sectionItem,
  }: {
    section: string;
    sectionItem?: string;
  }) {
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: 'menu_click',
      variant: newHeader ? 'new_header' : 'old_header',
      section,
      ...(sectionItem ? { section_item: sectionItem } : {}),
    });
  }

  return {
    sendMenuClickEvent,
  };
}
